export const NO_RESULTS_PROMPT_VERSIONS = {
  'no-exact-match': 'no-exact-match',
  'select-available-tlds': 'select-available-tlds',
  'new-search': 'new-search',
}

export const ADD_DOMAINS_LIST_LENGTH = 4

export const SUPPORTED_CC_TLDS_AND_CC_MAP = {
  cc: 'CC',
  ag: 'AG',
  ai: 'AI',
  am: 'AM',
  at: 'AT',
  be: 'BE',
  bz: 'BZ',
  ca: 'CA',
  ch: 'CH',
  cn: 'CN',
  co: 'CO',
  cz: 'CZ',
  de: 'DE',
  es: 'ES',
  fm: 'FM',
  gg: 'GG',
  gs: 'GS',
  in: 'IN',
  io: 'IO',
  la: 'LA',
  ms: 'MS',
  mx: 'MX',
  nl: 'NL',
  ph: 'PH',
  pl: 'PL',
  sg: 'SG',
  tc: 'TC',
  tk: 'TK',
  tv: 'TV',
  tw: 'TW',
  us: 'US',
  ws: 'WS',
  eu: 'EU',
  me: 'ME',
  'com.mx': 'MX',
  'co.uk': 'UK',
  'me.uk': 'UK',
  'org.uk': 'UK',
  'co.nz': 'NZ',
  'net.nz': 'NZ',
  'org.nz': 'NZ',
  'com.tw': 'TW',
  'org.tw': 'TW',
  'idv.tw': 'TW',
  'com.cn': 'CN',
  'net.cn': 'CN',
  'org.cn': 'CN',
  'com.ag': 'AG',
  'net.ag': 'AG',
  'org.ag': 'AG',
  'com.pl': 'PL',
  'net.pl': 'PL',
  'org.pl': 'PL',
  'biz.pl': 'PL',
  'info.pl': 'PL',
  'com.au': 'AU',
  'net.au': 'AU',
  'com.co': 'CO',
  'com.ph': 'PH',
  'co.za': 'ZA',
  'co.in': 'IN',
  'net.co': 'CO',
  'org.au': 'AU',
  'net.in': 'IN',
  'org.in': 'IN',
  'firm.in': 'IN',
  'gen.in': 'IN',
  'ind.in': 'IN',
  'com.es': 'ES',
  'com.ve': 'VE',
  'org.ve': 'VE',
  'com.bz': 'BZ',
  'net.bz': 'BZ',
  'nom.es': 'ES',
  'org.es': 'ES',
  'nom.co': 'CO',
  'co.ve': 'VE',
  'info.ve': 'VE',
  'net.ve': 'VE',
  'web.ve': 'VE',
  'net.ph': 'PH',
  'org.ph': 'PH',
}

export const SUGGESTION_PREFIXES = ['the', 'my', 'our']
export const SUGGESTION_SUFFIXES = [
  'store',
  'online',
  'web',
  'media',
  'group',
  'shop',
  'co',
]
